import { RootState } from "common/reducers";
import { ValidationKind, ValidationRecord } from "common/records/Validation";
import { ValidationUploadStatsRecord } from "common/records/ValidationUploadStats";
import { currentOrgId } from "src/common/selectors/org.selectors";

const rootKey = "validations";

/**
 * Gets the validation upload stats for the currentOrgId, or `undefined` if no stats are loaded for that org.
 */
export const currentOrgStats = (state: RootState): ValidationUploadStatsRecord | undefined =>
  state.getIn([rootKey, "uploadStatsByOrgId"]).get(currentOrgId(state) as number);

/**
 * Gets a validation rule record by id, or `undefined` if no rule with that id is loaded.
 */
export const validationById = (state: RootState, id: number): ValidationRecord | undefined =>
  state.getIn([rootKey, "byId", id]);

/**
 * Gets a validation rule by kind and item_uuid, or `undefined` if no matching rule is loaded.
 * The composite key is `${kind}-${itemUuid}`.
 */
export const validationFromItemUuid = (
  state: RootState,
  kind: ValidationKind,
  itemUuid: string,
): ValidationRecord | undefined => {
  const id = state.getIn([rootKey, "byItemUuid", `${kind}-${itemUuid}`]) as number | undefined;
  return id != null ? validationById(state, id) : undefined;
};
